import { DialogActions, DialogContent, DialogContentText, DialogTitle, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { AppTheme } from "../../../theme";
import { ButtonApp } from "../../commonStyles";
import DialogApp from "../../styledComponents/DialogApp/DialogApp";



function ConfirmationDialog(props: any) {
    const theme: AppTheme = useTheme();
    const [t] = useTranslation();

    const handleClose = () => {
        props.onClose();
    };

    const handleConfirm = () => {
        props.onConfirm();
    }

    return (
        <span>
            <DialogApp
                open={props.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm" 
            >
                <DialogTitle variant="h4" id="close-harvest-dialog-title" sx={{borderBottom: "1px solid " + theme.palette.neutral_4, p: "20px 32px 20px 32px"}}>
                    {props.title}
                </DialogTitle>
                <DialogContent sx={{overflowX: 'hidden', p: "20px 32px 20px 32px !important"}}>
                    <DialogContentText id="alert-dialog-description">
                        {props.subtitle}
                    </DialogContentText>
                    {props.alert != null &&
                        <DialogContentText id="alert-alert" sx={{marginTop: "30px", fontWeight: "bold"}}>
                            {props.alert}
                        </DialogContentText>
                    }
                </DialogContent>
                <DialogActions sx={{ margin: "30px"}}>
                    <ButtonApp
                        variant="outlined"
                        onClick={handleClose}
                        color="primary"
                        data-testid="button-cancel-alert"
                        sx={{mr: "10px"}}
                    >
                        {t('COMMON.CANCEL')}
                    </ButtonApp>
                    <ButtonApp
                        variant="contained"
                        onClick={handleConfirm}
                        color={props.color?props.color:"primary"}
                        data-testid="button-confirm-dialog"
                        autoFocus
                        disabled={!!props?.disabled}
                    >
                        {t('COMMON.CONFIRM')}
                    </ButtonApp>
                </DialogActions>
            </DialogApp>
        </span>
    )
}

export default ConfirmationDialog;
